import { render, staticRenderFns } from "./AffiliatePartnerMenu.vue?vue&type=template&id=723b8830&scoped=true&"
import script from "./AffiliatePartnerMenu.vue?vue&type=script&lang=js&"
export * from "./AffiliatePartnerMenu.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePartnerMenu.vue?vue&type=style&index=0&id=723b8830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b8830",
  null
  
)

export default component.exports